export default __webpack_public_path__ + "images/0D.3c9bdcb.png";